export default {"src":"/login-app/[GIT_HASH]/_next/static/media/priority_1.e373100a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};